// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1 2.5L9.48063 2.5L11.4806 5L23 5L23 21L1 21L1 2.5Z"}}]};

const FolderFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-filled',
    ref,
    icon: element,
  },
));

FolderFilledIcon.displayName = 'FolderFilledIcon';

export default FolderFilledIcon;
